/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

const $root = $protobuf.roots.Transcriber || ($protobuf.roots.Transcriber = {});

export const Tc2MessageTranscribeRequest = $root.Tc2MessageTranscribeRequest = (() => {

    function Tc2MessageTranscribeRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Tc2MessageTranscribeRequest.prototype.messageId = null;

    Tc2MessageTranscribeRequest.create = function create(properties) {
        return new Tc2MessageTranscribeRequest(properties);
    };

    Tc2MessageTranscribeRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
            $root.MessageIdentifier.encode(message.messageId, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    Tc2MessageTranscribeRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Tc2MessageTranscribeRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Tc2MessageTranscribeRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.messageId = $root.MessageIdentifier.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Tc2MessageTranscribeRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Tc2MessageTranscribeRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.Tc2MessageTranscribeRequest)
            return object;
        let message = new $root.Tc2MessageTranscribeRequest();
        if (object.messageId != null) {
            if (typeof object.messageId !== "object")
                throw TypeError(".Tc2MessageTranscribeRequest.messageId: object expected");
            message.messageId = $root.MessageIdentifier.fromObject(object.messageId);
        }
        return message;
    };

    Tc2MessageTranscribeRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.messageId = null;
        if (message.messageId != null && message.hasOwnProperty("messageId"))
            object.messageId = $root.MessageIdentifier.toObject(message.messageId, options);
        return object;
    };

    Tc2MessageTranscribeRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Tc2MessageTranscribeRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Tc2MessageTranscribeRequest";
    };

    return Tc2MessageTranscribeRequest;
})();

export const Tc2MessageTranscribeResponse = $root.Tc2MessageTranscribeResponse = (() => {

    function Tc2MessageTranscribeResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Tc2MessageTranscribeResponse.prototype.messageId = null;
    Tc2MessageTranscribeResponse.prototype.status = 0;
    Tc2MessageTranscribeResponse.prototype.transcription = "";

    Tc2MessageTranscribeResponse.create = function create(properties) {
        return new Tc2MessageTranscribeResponse(properties);
    };

    Tc2MessageTranscribeResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
            $root.MessageIdentifier.encode(message.messageId, writer.uint32(10).fork()).ldelim();
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
        if (message.transcription != null && Object.hasOwnProperty.call(message, "transcription"))
            writer.uint32(26).string(message.transcription);
        return writer;
    };

    Tc2MessageTranscribeResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Tc2MessageTranscribeResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Tc2MessageTranscribeResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.messageId = $root.MessageIdentifier.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.status = reader.int32();
                    break;
                }
            case 3: {
                    message.transcription = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Tc2MessageTranscribeResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Tc2MessageTranscribeResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.Tc2MessageTranscribeResponse)
            return object;
        let message = new $root.Tc2MessageTranscribeResponse();
        if (object.messageId != null) {
            if (typeof object.messageId !== "object")
                throw TypeError(".Tc2MessageTranscribeResponse.messageId: object expected");
            message.messageId = $root.MessageIdentifier.fromObject(object.messageId);
        }
        switch (object.status) {
        default:
            if (typeof object.status === "number") {
                message.status = object.status;
                break;
            }
            break;
        case "TRANSCRIBE_STATUS_UNSPECIFIED":
        case 0:
            message.status = 0;
            break;
        case "IN_PROGRESS":
        case 2:
            message.status = 2;
            break;
        case "COMPLETED":
        case 3:
            message.status = 3;
            break;
        case "FAILED":
        case 4:
            message.status = 4;
            break;
        }
        if (object.transcription != null)
            message.transcription = String(object.transcription);
        return message;
    };

    Tc2MessageTranscribeResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.messageId = null;
            object.status = options.enums === String ? "TRANSCRIBE_STATUS_UNSPECIFIED" : 0;
            object.transcription = "";
        }
        if (message.messageId != null && message.hasOwnProperty("messageId"))
            object.messageId = $root.MessageIdentifier.toObject(message.messageId, options);
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.TranscribeStatus[message.status] === undefined ? message.status : $root.TranscribeStatus[message.status] : message.status;
        if (message.transcription != null && message.hasOwnProperty("transcription"))
            object.transcription = message.transcription;
        return object;
    };

    Tc2MessageTranscribeResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Tc2MessageTranscribeResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Tc2MessageTranscribeResponse";
    };

    return Tc2MessageTranscribeResponse;
})();

export const MessageIdentifier = $root.MessageIdentifier = (() => {

    function MessageIdentifier(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MessageIdentifier.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    MessageIdentifier.prototype.ts = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    MessageIdentifier.prototype.chatId = "";

    MessageIdentifier.create = function create(properties) {
        return new MessageIdentifier(properties);
    };

    MessageIdentifier.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int64(message.id);
        if (message.ts != null && Object.hasOwnProperty.call(message, "ts"))
            writer.uint32(16).int64(message.ts);
        if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
            writer.uint32(26).string(message.chatId);
        return writer;
    };

    MessageIdentifier.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MessageIdentifier.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MessageIdentifier();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int64();
                    break;
                }
            case 2: {
                    message.ts = reader.int64();
                    break;
                }
            case 3: {
                    message.chatId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MessageIdentifier.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MessageIdentifier.fromObject = function fromObject(object) {
        if (object instanceof $root.MessageIdentifier)
            return object;
        let message = new $root.MessageIdentifier();
        if (object.id != null)
            if ($util.Long)
                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
            else if (typeof object.id === "string")
                message.id = parseInt(object.id, 10);
            else if (typeof object.id === "number")
                message.id = object.id;
            else if (typeof object.id === "object")
                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        if (object.ts != null)
            if ($util.Long)
                (message.ts = $util.Long.fromValue(object.ts)).unsigned = false;
            else if (typeof object.ts === "string")
                message.ts = parseInt(object.ts, 10);
            else if (typeof object.ts === "number")
                message.ts = object.ts;
            else if (typeof object.ts === "object")
                message.ts = new $util.LongBits(object.ts.low >>> 0, object.ts.high >>> 0).toNumber();
        if (object.chatId != null)
            message.chatId = String(object.chatId);
        return message;
    };

    MessageIdentifier.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.id = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.ts = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ts = options.longs === String ? "0" : 0;
            object.chatId = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            if (typeof message.id === "number")
                object.id = options.longs === String ? String(message.id) : message.id;
            else
                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.ts != null && message.hasOwnProperty("ts"))
            if (typeof message.ts === "number")
                object.ts = options.longs === String ? String(message.ts) : message.ts;
            else
                object.ts = options.longs === String ? $util.Long.prototype.toString.call(message.ts) : options.longs === Number ? new $util.LongBits(message.ts.low >>> 0, message.ts.high >>> 0).toNumber() : message.ts;
        if (message.chatId != null && message.hasOwnProperty("chatId"))
            object.chatId = message.chatId;
        return object;
    };

    MessageIdentifier.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MessageIdentifier.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MessageIdentifier";
    };

    return MessageIdentifier;
})();

export const TranscribeStatus = $root.TranscribeStatus = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "TRANSCRIBE_STATUS_UNSPECIFIED"] = 0;
    values[valuesById[2] = "IN_PROGRESS"] = 2;
    values[valuesById[3] = "COMPLETED"] = 3;
    values[valuesById[4] = "FAILED"] = 4;
    return values;
})();

export const ProblemDetail = $root.ProblemDetail = (() => {

    function ProblemDetail(properties) {
        this.extensions = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ProblemDetail.prototype.type = "";
    ProblemDetail.prototype.title = null;
    ProblemDetail.prototype.detail = "";
    ProblemDetail.prototype.status = 0;
    ProblemDetail.prototype.instance = "";
    ProblemDetail.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    ProblemDetail.prototype.traceId = "";
    ProblemDetail.prototype.extensions = $util.emptyObject;

    ProblemDetail.create = function create(properties) {
        return new ProblemDetail(properties);
    };

    ProblemDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(10).string(message.type);
        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
            $root.LocalizableString.encode(message.title, writer.uint32(18).fork()).ldelim();
        if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
            writer.uint32(26).string(message.detail);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(37).sfixed32(message.status);
        if (message.instance != null && Object.hasOwnProperty.call(message, "instance"))
            writer.uint32(42).string(message.instance);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(49).sfixed64(message.timestamp);
        if (message.traceId != null && Object.hasOwnProperty.call(message, "traceId"))
            writer.uint32(58).string(message.traceId);
        if (message.extensions != null && Object.hasOwnProperty.call(message, "extensions"))
            for (let keys = Object.keys(message.extensions), i = 0; i < keys.length; ++i)
                writer.uint32(66).fork().uint32(10).string(keys[i]).uint32(18).string(message.extensions[keys[i]]).ldelim();
        return writer;
    };

    ProblemDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ProblemDetail.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProblemDetail(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.string();
                    break;
                }
            case 2: {
                    message.title = $root.LocalizableString.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.detail = reader.string();
                    break;
                }
            case 4: {
                    message.status = reader.sfixed32();
                    break;
                }
            case 5: {
                    message.instance = reader.string();
                    break;
                }
            case 6: {
                    message.timestamp = reader.sfixed64();
                    break;
                }
            case 7: {
                    message.traceId = reader.string();
                    break;
                }
            case 8: {
                    if (message.extensions === $util.emptyObject)
                        message.extensions = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.extensions[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ProblemDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ProblemDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.ProblemDetail)
            return object;
        let message = new $root.ProblemDetail();
        if (object.type != null)
            message.type = String(object.type);
        if (object.title != null) {
            if (typeof object.title !== "object")
                throw TypeError(".ProblemDetail.title: object expected");
            message.title = $root.LocalizableString.fromObject(object.title);
        }
        if (object.detail != null)
            message.detail = String(object.detail);
        if (object.status != null)
            message.status = object.status | 0;
        if (object.instance != null)
            message.instance = String(object.instance);
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
        if (object.traceId != null)
            message.traceId = String(object.traceId);
        if (object.extensions) {
            if (typeof object.extensions !== "object")
                throw TypeError(".ProblemDetail.extensions: object expected");
            message.extensions = {};
            for (let keys = Object.keys(object.extensions), i = 0; i < keys.length; ++i)
                message.extensions[keys[i]] = String(object.extensions[keys[i]]);
        }
        return message;
    };

    ProblemDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.extensions = {};
        if (options.defaults) {
            object.type = "";
            object.title = null;
            object.detail = "";
            object.status = 0;
            object.instance = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            object.traceId = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.title != null && message.hasOwnProperty("title"))
            object.title = $root.LocalizableString.toObject(message.title, options);
        if (message.detail != null && message.hasOwnProperty("detail"))
            object.detail = message.detail;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
        if (message.instance != null && message.hasOwnProperty("instance"))
            object.instance = message.instance;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
        if (message.traceId != null && message.hasOwnProperty("traceId"))
            object.traceId = message.traceId;
        let keys2;
        if (message.extensions && (keys2 = Object.keys(message.extensions)).length) {
            object.extensions = {};
            for (let j = 0; j < keys2.length; ++j)
                object.extensions[keys2[j]] = message.extensions[keys2[j]];
        }
        return object;
    };

    ProblemDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ProblemDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ProblemDetail";
    };

    return ProblemDetail;
})();

export const LocalizableString = $root.LocalizableString = (() => {

    function LocalizableString(properties) {
        this.params = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LocalizableString.prototype.locKey = "";
    LocalizableString.prototype.params = $util.emptyArray;
    LocalizableString.prototype.pluralParam = 0;
    LocalizableString.prototype.defaultValue = "";

    LocalizableString.create = function create(properties) {
        return new LocalizableString(properties);
    };

    LocalizableString.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.locKey != null && Object.hasOwnProperty.call(message, "locKey"))
            writer.uint32(10).string(message.locKey);
        if (message.params != null && message.params.length)
            for (let i = 0; i < message.params.length; ++i)
                writer.uint32(18).string(message.params[i]);
        if (message.pluralParam != null && Object.hasOwnProperty.call(message, "pluralParam"))
            writer.uint32(24).int32(message.pluralParam);
        if (message.defaultValue != null && Object.hasOwnProperty.call(message, "defaultValue"))
            writer.uint32(34).string(message.defaultValue);
        return writer;
    };

    LocalizableString.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LocalizableString.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LocalizableString();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.locKey = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.params && message.params.length))
                        message.params = [];
                    message.params.push(reader.string());
                    break;
                }
            case 3: {
                    message.pluralParam = reader.int32();
                    break;
                }
            case 4: {
                    message.defaultValue = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LocalizableString.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LocalizableString.fromObject = function fromObject(object) {
        if (object instanceof $root.LocalizableString)
            return object;
        let message = new $root.LocalizableString();
        if (object.locKey != null)
            message.locKey = String(object.locKey);
        if (object.params) {
            if (!Array.isArray(object.params))
                throw TypeError(".LocalizableString.params: array expected");
            message.params = [];
            for (let i = 0; i < object.params.length; ++i)
                message.params[i] = String(object.params[i]);
        }
        if (object.pluralParam != null)
            message.pluralParam = object.pluralParam | 0;
        if (object.defaultValue != null)
            message.defaultValue = String(object.defaultValue);
        return message;
    };

    LocalizableString.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.params = [];
        if (options.defaults) {
            object.locKey = "";
            object.pluralParam = 0;
            object.defaultValue = "";
        }
        if (message.locKey != null && message.hasOwnProperty("locKey"))
            object.locKey = message.locKey;
        if (message.params && message.params.length) {
            object.params = [];
            for (let j = 0; j < message.params.length; ++j)
                object.params[j] = message.params[j];
        }
        if (message.pluralParam != null && message.hasOwnProperty("pluralParam"))
            object.pluralParam = message.pluralParam;
        if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
            object.defaultValue = message.defaultValue;
        return object;
    };

    LocalizableString.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    LocalizableString.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LocalizableString";
    };

    return LocalizableString;
})();

export { $root as default };
